import { useEffect, useState } from 'react';
import { mapsApi } from '../../api/maps';

/**
 * The road between two pins from InGo's engine (`POST routes`), as an encoded
 * polyline for `InGoMap`, or null until it answers, when routing is off, or
 * when it is not wanted (`enabled` false). Asked again only when a pin moves.
 *
 * @param {{ lat: number, lng: number } | null} from
 * @param {{ lat: number, lng: number } | null} to
 * @param {boolean} [enabled]
 */
export function useInGoRoad(from, to, enabled = true) {
  const [road, setRoad] = useState(null);
  const key = enabled && from && to ? `${from.lat},${from.lng};${to.lat},${to.lng}` : '';

  useEffect(() => {
    if (!key) {
      setRoad(null);
      return undefined;
    }
    let gone = false;
    const [a, b] = key.split(';').map((pair) => pair.split(',').map(Number));
    mapsApi.route([{ lat: a[0], lng: a[1] }, { lat: b[0], lng: b[1] }]).then(
      (route) => !gone && setRoad(route?.polyline ?? null),
      () => !gone && setRoad(null),
    );

    return () => {
      gone = true;
    };
  }, [key]);

  return road;
}
